import { render, staticRenderFns } from "./AthleteSideNav.vue?vue&type=template&id=e0719b78&scoped=true&"
import script from "./AthleteSideNav.vue?vue&type=script&lang=ts&"
export * from "./AthleteSideNav.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteSideNav.vue?vue&type=style&index=0&id=e0719b78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0719b78",
  null
  
)

export default component.exports